import { AppConfig } from './AppConfig';

const baseUrl = 'http://w-devl-05.pulsar.be';
const basePlannerUrl = 'http://w-devl-05.pulsar.be:8080';

const config: AppConfig = {
  configName: 'W-DEVL-05-DANGER-secours',
  applicationTitle: 'WebGardes',
  hubUrl: `${baseUrl}/pharmagardeHub`,
  apiUrl: `${baseUrl}/Pharmagarde-DANGER-secours/api/`,
  plannerApiUrl: `${basePlannerUrl}/planner/`,
  googleMapApiKey: 'AIzaSyAHKfZ1yH7pudlmQ4441Plv9Aiic1tunQc',
  dateFormat: 'DD/MM/YYYY',
  dateFormatWithDay: 'ddd DD/MM/YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
};

export default config;
